import { type RelatedAppType } from '../schema/InstalledRelatedApp';

const AppPlatform = {
    WEB_APP: 'webapp',
    PLAY_STORE: 'play',
};

const isGetInstalledRelatedAppsAPISupported = (navigator: Navigator) =>
    'getInstalledRelatedApps' in navigator && window.top === window.self;

export const getInstalledRelatedApps = async (): Promise<Map<RelatedAppType, RelatedApp>> => {
    const relatedApps = new Map<RelatedAppType, RelatedApp>();
    if (!isGetInstalledRelatedAppsAPISupported(navigator)) {
        return relatedApps;
    }

    const installedRelatedApps = await navigator.getInstalledRelatedApps();
    installedRelatedApps?.forEach(app => {
        const { platform, id } = app;
        switch (platform) {
            case AppPlatform.WEB_APP:
                relatedApps.set('MiniPWA', app);
                break;
            case AppPlatform.PLAY_STORE:
                if (id === 'com.microsoft.outlooklite') {
                    relatedApps.set('OlkLite', app);
                }
                break;
        }
    });

    return relatedApps;
};
